import { render, staticRenderFns } from "./PostPhotos.vue?vue&type=template&id=2c300ee5&"
import script from "./PostPhotos.vue?vue&type=script&lang=ts&"
export * from "./PostPhotos.vue?vue&type=script&lang=ts&"
import style0 from "./PostPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports